module.exports = __webpack_public_path__ + "static/media/reject-icon.dc6653c0.svg";